import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=42c95e5e&scoped=true&"
import script from "./Inquiries.vue?vue&type=script&lang=js&"
export * from "./Inquiries.vue?vue&type=script&lang=js&"
import style0 from "./Inquiries.vue?vue&type=style&index=0&id=42c95e5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c95e5e",
  null
  
)

export default component.exports